import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  // 简单带参数公开路由 - 协议查看
  {
    path: '/protocol/:type',
    name: 'protocolView',
    component: () => import('@/views/public/protocol/simple'),
    hidden: true,
    meta: {title: '协议查看', isPublic: true}
  },
  // 公告预览路由 - 公开访问
  {
    path: '/notice/preview',
    name: 'noticePreview',
    component: () => import('@/views/ums/notice/preview'),
    hidden: true,
    meta: {title: '公告预览', isPublic: true}
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'dashboard'}
    },
    // {
    //   name: 'document',
    //   path: 'https://www.macrozheng.com',
    //   meta: {title: '学习教程', icon: 'document'}
    // },
    // {
    //   name: 'video',
    //   path: 'https://www.macrozheng.com/mall/foreword/mall_video.html',
    //   meta: {title: '视频教程', icon: 'video'}
    // },
    ]
  },
  {
    path: '/dashboardDP',
    name: 'dashboard',
    meta: {title: '大屏看板', icon: 'dashboard'},
    component: () => import('@/views/home/dashboard'),
  },
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/index',
    meta: {title: '看板', icon: 'home'},
    children: [{
      path: 'index',
      name: 'dashboard',
      component: () => import('@/views/home/dashboard'),
      meta: {title: '看板', icon: 'dashboard'}
    }
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/mainProduct',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [
      {
        path: 'mainProduct',
        name: 'mainProduct',
        component: () => import('@/views/pms/product/index'),
        meta: {title: '主商城商品', icon: 'product-list', isMainProduct: true}
      },
      {
        path: 'addMainProduct',
        name: 'addMainProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加主商城商品', icon: 'product-add', isMainProduct: true}
      },
      {
        path: 'integrationProduct',
        name: 'integrationProduct',
        component: () => import('@/views/pms/product/index'),
        meta: {title: '积分商城商品', icon: 'product-list', isMainProduct: false}
      },
      {
        path: 'addIntegrationProduct',
        name: 'addIntegrationProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加积分商城商品', icon: 'product-add', isMainProduct: false}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '商品类型', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: {title: '秒杀活动列表', icon: 'sms-flash'}
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: {title: '秒杀时间段列表'},
        hidden:true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: {title: '秒杀时间段选择'},
        hidden:true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {title: '秒杀商品列表'},
        hidden:true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: {title: '品牌推荐', icon: 'product-brand'}
      },
      {
        path: 'fensheng-recommend',
        name: 'fenshengRecommend',
        component: () => import('@/views/sms/fensheng/recommend/index'),
        meta: {title: '芬省推荐', icon: 'sms-new'}
      },
      {
        path: 'fensheng-integration',
        name: 'fenshengIntegration',
        component: () => import('@/views/sms/fensheng/integration/index'),
        meta: {title: '消费有礼', icon: 'sms-new'}
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: {title: '新品推荐', icon: 'sms-new'}
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: {title: '人气推荐', icon: 'sms-hot'}
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '专题推荐', icon: 'sms-subject'}
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      }
    ]
  },
  {
    path: '/jms',
    component: Layout,
    redirect: '/jms/position',
    name: 'jms',
    meta: {title: '工作管理', icon: 'job'},
    children: [
      {
        path: 'city',
        name: 'city',
        component: () => import('@/views/jms/city/index'),
        meta: {title: '城市管理', icon: 'marker'}
      },
      {
        path: 'area',
        name: 'area',
        component: () => import('@/views/jms/area/index'),
        meta: {title: '区域管理', icon: 'position'}
      },
      {
        path: 'position',
        name: 'position',
        component: () => import('@/views/jms/position/index'),
        meta: {title: '岗位管理', icon: 'position'}
      },
      {
        path: 'addPosition',
        name: 'addPosition',
        component: () => import('@/views/jms/position/add'),
        meta: {title: '添加岗位'},
        hidden: true
      },
      {
        path: 'updatePosition',
        name: 'updatePosition',
        component: () => import('@/views/jms/position/add'),
        meta: {title: '修改岗位'},
        hidden: true
      },
      {
        path: 'company',
        name: 'company',
        component: () => import('@/views/jms/company/index'),
        meta: {title: '公司管理', icon: 'company'}
      },
      {
        path: 'addCompany',
        name: 'addCompany',
        component: () => import('@/views/jms/company/add'),
        meta: {title: '添加公司'},
        hidden: true
      },
      {
        path: 'updateCompany',
        name: 'updateCompany',
        component: () => import('@/views/jms/company/add'),
        meta: {title: '修改公司'},
        hidden: true
      },
      {
        path: 'companyDetail',
        name: 'companyDetail',
        component: () => import('@/views/jms/company/detail'),
        meta: {title: '公司详情'},
        hidden: true
      },
      {
        path: 'application',
        name: 'application',
        component: () => import('@/views/jms/application/index'),
        meta: {title: '申请管理', icon: 'application'}
      },
      {
        path: 'applicationDetail',
        name: 'applicationDetail',
        component: () => import('@/views/jms/application/detail'),
        meta: {title: '申请详情'},
        hidden: true
      },
      {
        path: 'category',
        name: 'category',
        component: () => import('@/views/jms/category/index'),
        meta: {title: '分类管理', icon: 'category'}
      },
      {
        path: 'addCategory',
        name: 'addCategory',
        component: () => import('@/views/jms/category/add'),
        meta: {title: '添加分类'},
        hidden: true
      },
      {
        path: 'updateCategory',
        name: 'updateCategory',
        component: () => import('@/views/jms/category/add'),
        meta: {title: '修改分类'},
        hidden: true
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'inviteCode',
        name: 'inviteCode',
        component: () => import('@/views/ums/inviteCode/index'),
        meta: {title: '邀请码管理', icon: 'ums-admin'}
      },
      {
        path: 'article',
        name: 'article',
        component: () => import('@/views/ums/article/index'),
        meta: {title: '文章管理', icon: 'document'}
      },
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/ums/notice/index'),
        meta: {title: '公告管理', icon: 'document'}
      },
      {
        path: 'material',
        name: 'material',
        component: () => import('@/views/ums/material/index'),
        meta: {title: '素材管理', icon: 'document'}
      },
      {
        path: 'addMaterial',
        name: 'addMaterial',
        component: () => import('@/views/ums/material/add'),
        meta: {title: '添加素材'},
        hidden: true
      },
      {
        path: 'updateMaterial',
        name: 'updateMaterial',
        component: () => import('@/views/ums/material/update'),
        meta: {title: '编辑素材'},
        hidden: true
      },
      {
        path: 'ums-application',
        name: 'ums-application',
        component: () => import('@/views/ums/application/index'),
        meta: {title: '应用管理', icon: 'ums-admin'}
      },
      {
        path: 'protocol',
        name: 'protocol',
        component: () => import('@/views/ums/protocol/index'),
        meta: {title: '协议管理', icon: 'document'}
      },
      {
        path: 'addProtocol',
        name: 'addProtocol',
        component: () => import('@/views/ums/protocol/add'),
        meta: {title: '添加协议'},
        hidden: true
      },
      {
        path: 'updateProtocol',
        name: 'updateProtocol',
        component: () => import('@/views/ums/protocol/update'),
        meta: {title: '编辑协议'},
        hidden: true
      },
      {
        path: 'systemSetting',
        name: 'systemSetting',
        component: () => import('@/views/ums/systemSetting/index'),
        meta: {title: '系统设置', icon: 'document'}
      },
      {
        path: 'addSystemSetting',
        name: 'addSystemSetting',
        component: () => import('@/views/ums/systemSetting/add'),
        meta: {title: '添加系统设置'},
        hidden: true
      },
      {
        path: 'updateSystemSetting',
        name: 'updateSystemSetting',
        component: () => import('@/views/ums/systemSetting/update'),
        meta: {title: '编辑系统设置'},
        hidden: true
      },
      {
        path: 'memberFeaturePermission',
        name: 'memberFeaturePermission',
        component: () => import('@/views/ums/memberFeaturePermission/index'),
        meta: {title: '用户功能权限', icon: 'permission'}
      },
      {
        path: 'addMemberFeaturePermission',
        name: 'addMemberFeaturePermission',
        component: () => import('@/views/ums/memberFeaturePermission/add'),
        meta: {title: '添加功能权限'},
        hidden: true
      }
    ]
  },
  {
    path:'/fcms',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '加购劵管理', icon: 'ums'},
    children: [
      {
        path: 'couponSettlement',
        name: 'couponSettlement',
        component: () => import('@/views/ums/fensheng-coupon/coupon-settlement'),
        meta: {title: '加购劵结算', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/masms',
    component: Layout,
    redirect: '/ums/admin',
    name: 'masms',
    meta: {title: '管理和统计', icon: 'masms'},
    children: [
      {
        path: 'memberManagement',
        name: 'memberManagement',
        component: () => import('@/views/masms/member/index'),
        meta: {title: '会员管理', icon: 'ums-admin'}
      },
      {
        path: 'member/detail',
        name: 'memberDetail',
        component: () => import('@/views/masms/member/member-detail'),
        meta: {title: '会员详情'},
        hidden: true
      },
      {
        path: 'member/fensheng-integration',
        name: 'memberFenshengIntegration',
        component: () => import('@/views/masms/member/member-fensheng-integration'),
        meta: {title: '芬省积分详情'},
        hidden: true
      },
      {
        path: 'member/asset',
        name: 'memberAsset',
        component: () => import('@/views/masms/member/member-asset'),
        meta: {title: '资产信息'},
        hidden: true
      },
      {
        path: 'member/fensheng-coupon',
        name: 'memberFenshengCoupon',
        component: () => import('@/views/masms/member/member-fensheng-coupon'),
        meta: {title: '加购券详情'},
        hidden: true
      },
      {
        path: 'member/shopping-integration',
        name: 'memberShoppingIntegration',
        component: () => import('@/views/masms/member/member-shopping-integration'),
        meta: {title: '购物积分详情'},
        hidden: true
      },
      {
        path: 'member/permission',
        name: 'memberPermission',
        component: () => import('@/views/masms/member/member-permission'),
        meta: {title: '权限管理'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js